export const medicareCardColorOptions = [
  {
    label: 'Green',
    value: 'green',
  },
  {
    label: 'Blue',
    value: 'blue',
  },
  {
    label: 'Yellow',
    value: 'yellow',
  },
];
